import moment from 'moment';

// CONVERT
export function convertSecond2010ToDateTime (secs) {
  return moment([2010, 0, 1, 0, 0, 0, 0]).add(secs, 'seconds');
}

export function convertDateTimeToSecond2010 (date) {
  let mSecond2010 = moment([2010, 0, 1, 0, 0, 0, 0]).unix();
  let mSecondDate = moment(date).unix();
  return (mSecondDate - mSecond2010);
}

export function convertSecondToRelativeTime (secs) {
  return convertSecond2010ToDateTime(secs).locale('vi').fromNow();
}

export function getBeginOfDayAsSecond (date) {
  let startOfDate = moment(date).startOf('day');
  let seconds = convertDateTimeToSecond2010(startOfDate);
  return seconds;
}

export function getEndOfDayAsSecond (date) {
  let endOfDate = moment(date).endOf('day');
  let seconds = convertDateTimeToSecond2010(endOfDate);
  return seconds;
}

// FORMAT
export function formatSecondToGPSTime (secs) {
  return convertSecond2010ToDateTime(secs).format('YYYY-MM-DD, HH:mm:ss');
}

export function formatSecondToYYMMDD (secs) {
  return convertSecond2010ToDateTime(secs).format('YYYY-MM-DD');
}

export function formatSecondToHHmm (secs) {
  return convertSecond2010ToDateTime(secs).format('HH:mm');
}

export function formatSecondToYYMMDDHHmm (secs) {
  return convertSecond2010ToDateTime(secs).format('YYYY-MM-DD HH:mm');
}

export function formatSecondToDuration (totalSeconds) {

  if (totalSeconds > 0) {
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    let result = '';

    if (hours > 0) {
      result += `${hours}h `;
    }
    if (minutes > 0) {
      result += `${minutes}m `;
    }
    if (seconds > 0) {
      result += `${seconds}s`;
    }

    return result;
  } else {
    return '---';
  }
}

export function formatDate (date) {
  return moment(date).format('YYYY-MM-DD');
}

export function formatDateTime (date) {
  return moment(date).format('YYYY-MM-DD HH:mm');
}

export function addDate (date, numberOfDate) {
  return moment(date).add(numberOfDate, 'days');
}

export function formatExportDate (date) {
  return moment(date).format('YYYYMMDDHHmmss');
}



// WEBPACK FOOTER //
// ./src/utils/datetime.js